import { createContext, useContext, useEffect, useMemo, useReducer } from 'react';
import { DataManagementContext } from '../../components/viewers/DataManagementViewer';
import { gEnums } from '../../enums/globalEnums';
import { DataModificationsContext } from '../../pageItem/modification/UiDataModifications';
import { dataModificationTypes } from '../../viewSettings/enums/itemActionTypes';
import { frameworkLeftTypes } from '../reducers/FrameworkReducer';
import { uploadHandlers, uploadInitialState, uploadReducer } from '../reducers/UploadReducer';
import { DataModifyContext } from './DataModifyContext';
import { FrameworkContext } from './FrameworkContent';
import { ParentContext } from './ParentContext';
import { UiItemContext } from './UiItemContext';
import { useAppUserAccess } from './useHelpers/useAppUserAccess';
import { useImage } from './useHelpers/useImage';

export const UploadContext = createContext();

const UploadProvider = (props) => {

  const {
    handleCancel,
    itemData: altItemData,
    storageLocationType,
    origin,
    appImage,
  } = props

  let { storageType } = props
  if (!storageType) { storageType = gEnums.storageTypes.image }

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, handlers } = parentContext ?? {}
  const { currentSettings_state, app_state, appUser_state, eventInfo_state, paps_state, storage_state } = states
  const { mainStorage } = app_state ?? {}
  const { appDataDocuments, clientProfiles } = eventInfo_state ?? {}
  const { aps_global, aps_appUserSettings } = _.get(currentSettings_state, 'gvviSettings', {});
  const { productionSettings, storageOptions } = aps_global ?? {}
  const { appUserCollection, useClientProfileImage } = aps_appUserSettings ?? {}
  const { appStorageUrlFiles, galleries, imageProps_edit } = storage_state ?? {}

  // authContext 
  const { appUser, appUsers } = appUser_state ?? {}
  const appUserAccess = useAppUserAccess()

  // dataManagementContext
  const frameworkContext = useContext(FrameworkContext)
  const { framework_state, framework_handlers } = frameworkContext ?? {}
  const { selectedCollectionKey, frInfo, selectedDataMode, currentLongPress } = framework_state ?? {}
  const { longPressData, longPressType } = currentLongPress ?? {}
  const { currentPageData, viewListData } = frInfo ?? {}
  const { handleShow_appDashboard } = framework_handlers ?? {}

  // dataManagementContext
  const dataModificationContext = useContext(DataModificationsContext)
  const { dataModifications_state } = dataModificationContext ?? {}
  const { appData: appData_dmod } = dataModifications_state ?? {}

  // dataManagementContext
  const dataManagementContext = useContext(DataManagementContext)
  const { dataManagement_state } = dataManagementContext ?? {}
  const { viewItem, appData: appData_dman, dataManagementType } = dataManagement_state ?? {}
  const { key: viewItemKey_dm } = viewItem ?? {}

  // dataModifyContext
  const dataModifyContext = useContext(DataModifyContext)
  const { dataModify_state } = dataModifyContext ?? {}
  const { dataModificationType } = dataModify_state ?? {}

  // uiItemContext
  const uiItemContext = useContext(UiItemContext);
  const { item_state } = uiItemContext ?? {}
  const { viewItem: viewItem_item, dataItem } = item_state ?? {}
  const { key: viewItemKey } = viewItem_item ?? {}


  const _appImage = useImage({ imageProps: imageProps_edit })
  const _app_image = _appImage || appImage

  // papsContext 
  const { storagePaths, pathViews, storageRootPath, view, viewKey, lastView, lastViewKey } = paps_state

  let _noMid = false

  switch (origin) {
    case 'uiUpload':
      _noMid = false
      break;
    case 'manifestViewer':
      _noMid = true
      break;
    default:
    // nothing
  }

  let _showBulkUploader = false;

  switch (dataManagementType) {
    case dataModificationTypes.upload_storageImages:
    case dataModificationTypes.bulkImageUpload:
      _showBulkUploader = true
      break;
    default:
      break;
  }

  switch (dataModificationType) {
    case dataModificationTypes.bulkImageUpload:
      _showBulkUploader = true
      break;
    default:
      // nothing
      break;
  }

  if (selectedDataMode === frameworkLeftTypes.bulkImageUpload) {
    _showBulkUploader = true
  }

  let _viewItemKey = viewItemKey_dm ? viewItemKey_dm : viewItemKey
  if (props.viewItemKey) { _viewItemKey = props.viewItemKey }
  if (selectedCollectionKey) {
    _viewItemKey = selectedCollectionKey
  }

  const _handleCancel = handleShow_appDashboard ? handleShow_appDashboard : handleCancel

  const viewUploadProps = { view: lastView, viewKey: lastViewKey }
  if (storageLocationType === gEnums.storageLocationTypes.profiles) { viewUploadProps.imageUrlOnly = true }

  let _appData = appData_dmod ? appData_dmod : appData_dman

  if (!_appData && viewListData) {
    _appData = viewListData
  }

  if (appDataDocuments && appDataDocuments[_viewItemKey]) {
    _appData = appDataDocuments[_viewItemKey]
  }

  const init_state = {
    xxx: {
      appUser,
      appUsers,
      currentSettings_state,
      galleries,
      appStorageUrlFiles,
    },
    appImage: _app_image,
    altItemData,
    appUserAccess,
    appUserCollection,
    currentPageData,
    longPressData,
    dataItem,
    dataModificationType,
    handleCancel: _handleCancel,
    handlers,
    lastView,
    pathViews,
    productionSettings,
    showBulkUploader: _showBulkUploader,
    storageLocationType,
    storageOptions,
    storagePaths,
    storageRootPath,
    storageType,
    useClientProfileImage,
    view,
    viewItemKey: _viewItemKey,
    viewKey,
    viewListData: _appData,
    viewUploadProps,
    mainStorage,
    imageProps_edit,
  }

  const [upload_state, uploadDispatch] = useReducer(uploadReducer, uploadInitialState(init_state));

  const upload_handlers = useMemo(
    () => uploadHandlers(uploadDispatch),
    [uploadDispatch]
  );

  useEffect(() => {
    upload_handlers.handleInit_upload(init_state)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_viewItemKey]);

  return <UploadContext.Provider value={{ upload_state, upload_handlers }}>
    {props.children}
  </UploadContext.Provider>
};

export default UploadProvider